import React from "react";
import "../../css/index.css";
//src image
import banner from '../../img/banner.png';
import logo from '../../img/mulogo.png';

import { connect } from "react-redux";
import { useDispatch } from 'react-redux'
import { Image } from "../../img";
import { matchRoutes, useLocation } from "react-router-dom"

const Header = (props) => {
    const dispatch=useDispatch();
    const currentLocation = useLocation();
    
    if (currentLocation.pathname=='/'||currentLocation.pathname=='')
    return(
        <div className='header'>
            <img className="headerMenuButton" src={Image.Menu} onClick={()=>{
                dispatch({type:'COMMON_SET_MENUSHOW',payload:true})
            }}/>
            <img className='logo' src={logo} alt="Banner" width="100%" height="auto"></img>
        </div>
    )
    else {
        return (
            <div className='header headerOtherPage' style={{display:'flex'}}>
                <div style={{flex:1,    display: 'flex',height: '57px'}}>
                    <img className="headerMenuButton" src={Image.Menu} onClick={()=>{
                        dispatch({type:'COMMON_SET_MENUSHOW',payload:true})
                    }}/>
                    <div className={'HeaderTitleContain'} >
                        <span className={'HeaderTitleFirst'}>Getting started with</span>
                        <span className={'HeaderTitleOLE'}> OLE</span>
                        
                        <br/>
                        <span className={'HeaderTitleThird'}>for full-time teaching staff</span>
                    </div>
                </div>
                <img className='logoSmall' src={logo} alt="Banner" width="100%" height="auto" ></img>
            </div>
        )
    }
}

export default Header;